export default "__VITE_ASSET__DF8$u8GG__"